import { useQuery } from "@tanstack/react-query";

import { keywordsGroupService } from "app/services/keywordsGroup/keywordsGroupService";
import { SharingService } from "app/sharing/SharingService";

export const useAccountUsers = () =>
    useQuery({
        queryKey: ["account-users"],
        enabled: keywordsGroupService.canShareKeywordsGroup(),
        queryFn: () => SharingService.getAccountUsers().then((response) => response.users),
    });
